function reportError(error, info) {
  // TODO - log to sentry, splunk?
  console.error(error, info)
}
export default reportError
